import { useSyncQueueStore } from '@/lib/helpers/bgSync/useSyncQueueStore.ts'
import type { QueueItemT } from '@/lib/types/bgSyncTypes.ts'

// Set of `meta.type` values whose queued items, while present, mean the
// optimistic React Query cache we wrote for that resource must not be
// refetched. While these entries are still in flight the server only sees a
// partial state — refetching now would tear down the optimistic UI and
// replace it with whatever fraction of the bulk has reached the database so
// far. Once the queue empties for a type, `useQueueDrainInvalidator` fires a
// single invalidation that reconciles cache with server-truth.
const ACTIVE_METHODS = new Set(['POST', 'PATCH'])

function isActiveEntry(item: QueueItemT, type: string): boolean {
  return (
    item.metadata.type === type &&
    ACTIVE_METHODS.has(item.metadata.method) &&
    !item.metadata.permanentFailure
  )
}

export function hasPendingQueueEntriesForType(type: string): boolean {
  const queue = useSyncQueueStore.getState().data
  return queue.some(item => isActiveEntry(item, type))
}

export function countPendingQueueEntriesForType(type: string, queue: QueueItemT[]): number {
  let n = 0
  for (const item of queue) if (isActiveEntry(item, type)) n++
  return n
}
